module.exports = __webpack_public_path__ + "img/plan3_book03.a8887d96.png";